import React, {useEffect, useRef, useState} from "react";
import "./ListPrescriptions.scss";
import {Tabs} from "antd";
import {ExpandSearch} from "components/common";

import {inputFields as inputFieldsInit, items} from "./config";
import {FORMAT_TIME, tabKeys} from "types/enums";
import {useAppDispatch, useAppSelector} from "redux/hooks";
import {setButtonsHeader} from "redux/reducer/common";
import dayjs from "dayjs";
import {
  setActiveTabPresciption,
  setExpandRef,
  setSearchForm,
} from "redux/reducer/medicineStore";
import {formatDateToString} from "helper/common";

const ListPrescription = () => {
  const activeKey = useAppSelector(state => state.common.activeTab);
  const activeTabPrescription = useAppSelector(
    state => state.medicineStore.activeTabPresciption
  );
  const [inputFields, setInputFields] = useState(inputFieldsInit);
  const dispatch = useAppDispatch();
  const expandRef = useRef(null);
  useEffect(() => {
    if (activeKey == tabKeys.MEDICINE_STORE.LIST_PRESCRIPTION) {
      dispatch(setButtonsHeader([]));
    }
  }, [activeKey]);
  useEffect(() => {
    dispatch(setExpandRef(expandRef?.current));
  }, [expandRef?.current]);
  useEffect(() => {
    expandRef?.current?.setFieldValue("start-ngay-tao", dayjs());
    expandRef?.current?.setFieldValue("end-ngay-tao", dayjs());
  }, []);
  useEffect(() => {
    setFieldsShow();
    setFieldsValue();
  }, [activeTabPrescription]);
  const setFieldsValue = () => {
    expandRef?.current?.resetFields();
    if (activeTabPrescription == tabKeys.MEDICINE_STORE.LIST_2) {
      expandRef?.current?.setFieldValue("start-ngay-mua", dayjs());
      expandRef?.current?.setFieldValue("end-ngay-mua", dayjs());
      dispatch(
        setSearchForm({
          ["start-ngay-mua"]: formatDateToString(dayjs(), FORMAT_TIME.dayFull),
          ["end-ngay-mua"]: formatDateToString(dayjs(), FORMAT_TIME.dayFull),
        })
      );
    } else if (activeTabPrescription == tabKeys.MEDICINE_STORE.LIST_1) {
      expandRef?.current?.setFieldValue("start-ngay-tao", dayjs());
      expandRef?.current?.setFieldValue("end-ngay-tao", dayjs());
      dispatch(
        setSearchForm({
          ["start-ngay-tao"]: formatDateToString(dayjs(), FORMAT_TIME.dayFull),
          ["end-ngay-tao"]: formatDateToString(dayjs(), FORMAT_TIME.dayFull),
        })
      );
    } else {
      expandRef?.current?.setFieldValue("thoiGianTra", dayjs());
      dispatch(
        setSearchForm({
          ["thoiGianTra"]: formatDateToString(dayjs(), FORMAT_TIME.dayFull),
        })
      );
    }
  };
  const setFieldsShow = () => {
    inputFieldsInit.find(e => e.name == "thoiGianTra").hide =
      activeTabPrescription != tabKeys.MEDICINE_STORE.LIST_3;
    inputFieldsInit.find(e => e.name == "start-ngay-mua").hide =
      activeTabPrescription == tabKeys.MEDICINE_STORE.LIST_1;
    inputFieldsInit.find(e => e.name == "end-ngay-mua").hide =
      activeTabPrescription == tabKeys.MEDICINE_STORE.LIST_1;
    setInputFields([...inputFieldsInit]);
  };
  const onClickSearchButton = () => {
    var searchFields = expandRef?.current?.getData();
    dispatch(
      setSearchForm({
        ...searchFields,
        page: 1,
        ["ngay-sinh-start"]: formatDateToString(
          searchFields["ngay-sinh-start"],
          FORMAT_TIME.dayFull
        ),
        ["ngay-sinh-end"]: formatDateToString(
          searchFields["ngay-sinh-end"],
          FORMAT_TIME.dayFull
        ),
        ["start-ngay-tao"]: formatDateToString(
          searchFields["start-ngay-tao"],
          FORMAT_TIME.dayFull
        ),
        ["end-ngay-tao"]: formatDateToString(
          searchFields["end-ngay-tao"],
          FORMAT_TIME.dayFull
        ),
        ["start-ngay-mua"]: formatDateToString(
          searchFields["start-ngay-mua"],
          FORMAT_TIME.dayFull
        ),
        ["end-ngay-mua"]: formatDateToString(
          searchFields["end-ngay-mua"],
          FORMAT_TIME.dayFull
        ),
        ["thoiGianTra"]: formatDateToString(
          searchFields["thoiGianTra"],
          FORMAT_TIME.dayFull
        ),
      })
    );
  };
  const onChangeTabList = key => {
    dispatch(setActiveTabPresciption(key));
  };

  return (
    <div className="listPrescriptions-container">
      <div className="container">
        <ExpandSearch
          ref={expandRef}
          onClickSearch={onClickSearchButton}
          fields={inputFields}
          onReset={() => {
            onClickSearchButton();
          }}
        ></ExpandSearch>
      </div>
      <div className="">
        <Tabs
          activeKey={activeTabPrescription}
          onChange={onChangeTabList}
          items={items}
        />
      </div>
    </div>
  );
};

export default ListPrescription;
